export type LangCode = "az" | "en" | "ru";
export type RouteKey = keyof typeof ROUTE_SLUGS;

export const VALID_LANGS: LangCode[] = ["az", "en", "ru"];

export const ROUTE_SLUGS = {
  home:                 { az: "",                       en: "",                       ru: "" },
  about:                { az: "haqqimizda",              en: "about",                  ru: "o-nas" },
  tariffs:              { az: "tarifler",                en: "tariffs",                ru: "tarify" },
  contact:              { az: "elaqe",                   en: "contact",                ru: "kontakty" },
  innovations:          { az: "yenilikler",              en: "innovations",            ru: "novosti" },
  stores:               { az: "magazalar",               en: "stores",                 ru: "magaziny" },
  questions:            { az: "suallar",                 en: "faq",                    ru: "voprosy" },
  forbidden:            { az: "qadagan-mehsullar",       en: "forbidden-products",     ru: "zapreshennye-tovary" },
  orderService:         { az: "sifaris-xidmeti",         en: "order-service",          ru: "servis-zakazov" },
  transportConditions:  { az: "dasima-shertleri",        en: "transport-conditions",   ru: "usloviya-dostavki" },
  privacyPolicy:        { az: "gizlilik-siyaseti",       en: "privacy-policy",         ru: "politika-konfidentsialnosti" },
  userAgreement:        { az: "istifadeci-razilasmasi",  en: "user-agreement",         ru: "polzovatelskoe-soglashenie" },
  dangerousPackages:    { az: "tehlikeli-baglamalar",    en: "dangerous-packages",     ru: "opasnye-tovary" },
  corporate:            { az: "korporativ",              en: "corporate",              ru: "korporativnyy" },
  services:             { az: "xidmetler",               en: "services",               ru: "uslugi" },
} as const;

/** Given a URL slug, find which route key it belongs to */
export function findRouteKey(slug: string): RouteKey | null {
  for (const [key, langs] of Object.entries(ROUTE_SLUGS)) {
    if ((Object.values(langs) as string[]).includes(slug)) {
      return key as RouteKey;
    }
  }
  return null;
}

/** Build full path: /{lang}/{slug} */
export function buildLangPath(lang: LangCode, routeKey: RouteKey): string {
  const slug = ROUTE_SLUGS[routeKey][lang];
  return slug ? `/${lang}/${slug}` : `/${lang}`;
}
